import { chakra, Flex as CkFlex } from '@chakra-ui/react'

export const DatePickerWrapper = chakra(CkFlex, {
  baseStyle: () => ({
    border: 'solid 1px',
    borderColor: 'background.grey.200',
    paddingX: '1rem',
    paddingY: '8px',
    borderRadius: '6px',
    paddingBottom: '10px',
    justifyContent: 'space-between',
    height: 10
  })
})
